import React from 'react';
import DealerList from '../components/DealerList';
import MainHeader from '../components/Main/MainHeader';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
const Categories = () => {
  const { category } = useParams();

  const title = `Anyworq – ${category.charAt(0).toUpperCase() + category.slice(1)} Services in India`;
  const description = `Find trusted ${category} service providers in India. Book easily on Anyworq.`;
  const canonicalUrl = `https://www.anyworq.com/categories/${category}`;

  return (
    <>
    <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
    
    
    <div>
      <MainHeader />
      <DealerList /></div>
      </>
  );
};

export default Categories;